import { Model } from '@vuex-orm/core';

class MemberDeviation extends Model {
  static entity = 'member-deviations';

  static primaryKey = 'user';

  static fields() {
    return {
      user: this.attr(null),
      deviations: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchByGroupName(name) {
        return this.get(`groups/${name}/deviations`, {
          dataTransformer: ({ data }) => {
            this.model.deleteAll();
            return data;
          },
        });
      },
      fetchByGroupAndUser(groupName, userId) {
        return this.get(`groups/${groupName}/users/${userId}/deviations`);
      },
    },
  }
}

export default MemberDeviation;
